import { h, toast } from '../dom';
import { login } from '../../auth/oidc';
import { remoteConfig } from '../../config';

const IDP_LABEL: Record<string, string> = { google: 'Google', zalo: 'Zalo', facebook: 'Facebook', apple: 'Apple' };

/**
 * A 4-cut strip like the ones Life4Cuts / Photoism print: two people from two cities
 * posing in the same frame, four poses, date stamp at the bottom. Pure CSS/SVG (no photos).
 */
function strip(): HTMLElement {
  const person = (cls: string) =>
    `<svg class="who ${cls}" viewBox="0 0 60 80" aria-hidden="true">
       <circle cx="30" cy="22" r="14"/><path d="M4 80c0-20 11-34 26-34s26 14 26 34z"/>
     </svg>`;
  const shots = ['hearts', 'caro', 'stars', 'milk'].map((bg, i) =>
    `<div class="cut bg-${bg} pose-${i + 1}">
       ${person('a')}${person('b')}
       <span class="tag a">Hà Nội</span><span class="tag b">Sài Gòn</span>
     </div>`).join('');
  const d = new Date();
  const date = `${String(d.getDate()).padStart(2, '0')}.${String(d.getMonth() + 1).padStart(2, '0')}.${d.getFullYear()}`;
  const el = h('figure.strip4', { 'aria-hidden': 'true' });
  el.innerHTML = `${shots}<figcaption><b>Booth Together</b><span>${date}</span></figcaption>`;
  return el;
}

export function renderLogin(root: HTMLElement) {
  const status = h('p.auth-note', {}, 'Đang kết nối máy chủ…');
  const buttons = h('div.loginbtns');
  const go = (opts: Parameters<typeof login>[0]) => login(opts).catch((e) => toast((e as Error).message, 4000));

  root.replaceChildren(h('main.auth', {},
    h('section.auth-hero', {},
      h('p.auth-brand', {}, 'Booth', h('em', {}, 'Together')),
      h('h1', {}, 'Hai nơi,', h('br'), 'một khung hình.'),
      h('p.auth-lede', {},
        'Gửi mã phòng cho bạn, cùng tạo dáng và chụp 4 kiểu cùng lúc — ảnh ghép lại như đang đứng cạnh nhau trong tiệm photobooth.'),
      strip(),
    ),
    h('section.auth-panel', {},
      h('div.auth-card', {},
        h('h2', {}, 'Chào bạn 👋'),
        h('p.auth-sub', {}, 'Đăng nhập để lưu ảnh, kết bạn và mời bạn bè vào phòng chụp.'),
        buttons,
        status,
      ),
      h('div.auth-quick', {},
        h('div', {},
          h('b', {}, 'Thử ngay, không cần tài khoản'),
          h('p', {}, 'Chụp với 1 người bằng mã phòng. Ảnh không được lưu, chỉ tải được bản xem trước.')),
        h('a.secondary.btn', { href: '#/quick' }, 'Chụp nhanh')),
      h('a.auth-settings', { href: '#/privacy' }, 'Chính sách quyền riêng tư'),
      h('a.auth-settings', { href: '#/settings' }, 'Cài đặt máy chủ'),
    ),
  ));

  void remoteConfig().then((cfg) => {
    if (!cfg) {
      status.textContent = 'Chưa kết nối được máy chủ. Kiểm tra mạng, hoặc mở Cài đặt máy chủ.';
      buttons.replaceChildren(h('button.primary', { onclick: () => location.reload() }, 'Thử lại'));
      return;
    }
    status.textContent = 'Bạn đăng nhập trên trang bảo mật của Booth Together — app không giữ mật khẩu của bạn.';
    buttons.replaceChildren(
      h('button.primary', { onclick: () => go({ returnTo: '#/feed' }) }, 'Đăng nhập'),
      h('button.secondary', { onclick: () => go({ register: true, returnTo: '#/me' }) }, 'Tạo tài khoản'),
      ...cfg.identityProviders.map((idp) =>
        h('button.idp', { onclick: () => go({ idp, returnTo: '#/feed' }) }, `Tiếp tục với ${IDP_LABEL[idp] ?? idp}`)),
    );
  });
}
